export const adaptAllUsuarioSolicitante = (usuario) => {
    return {
        id: usuario?.idUsuario,
        displayName: usuario?.apellido + " " +usuario?.nombre
    }
}

export const adaptAllUsuarioSolicitanteArray = (
    usuarios
) => {
    return structuredClone(usuarios?.allUsuarioSolicitantePrecioMasivo)
        ?.map(usuario => adaptAllUsuarioSolicitante(usuario));
}